let router;

export const setRouter = (instance) => {
  router = instance;
};

export const getRouter = () => router;

export default router;
